export const TO_NUMBER = 'TO_NUMBER'
export const CONTACTS = 'CONTACTS'
export const TEMPLATES = 'TEMPLATES'